import React from "react";

export default function Refund() {
  return (
    <>
      <section className="mt-32">
        <div className="container mx-auto">
          <div className="text-center">
            <h1 className="text-3xl " style={{ color: "#140342 "}}>Refund Policy</h1>
          </div>
        </div>
      </section>

      <section className="pt-12 pb-16 mb-12 text-justify">
        <div className="container mx-auto">
          <div className="flex justify-center">
            <div className="w-full max-w-5xl">
              <p className="mt-[30px] text-lg leading-relaxed" style={{ color: "#4F547B", fontSize: "18.75px" }}>
                Thank you for choosing our services. Please note that all sales are final. <span className="font-bold">NEET SUPPORT</span> does not offer refunds for any services rendered, as our offerings are digital and delivered immediately upon payment. Once a payment is processed, it cannot be reversed.
              </p>
              <p className="mt-[15px] text-lg leading-relaxed" style={{ color: "#4F547B", fontSize: "18.75px" }}>
                If you have any questions or concerns about our services, please feel free to reach out to us at:{" "}
                <a href="mailto:support@neetsupport.com" className="text-primary underline">
                  support@neetsupport.com
                </a>{" "}
                before making a purchase.
              </p>
              <p className="mt-[15px] text-lg leading-relaxed" style={{ color: "#4F547B", fontSize: "18.75px" }}>Thank you for your understanding.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
